<template>
<svg
  :width="width"
  :height="height"
  viewBox="0 0 32 33"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  :id="iconName"
>
    <title :id="iconName">{{iconName}}</title>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="RetVejkode-left-panel" transform="translate(-25.000000, -85.000000)">
            <g id="Group-17" transform="translate(-230.000000, 0.000000)">
                <g id="Vejkode-ikon" transform="translate(255.000000, 85.000000)">
                    <g id="Group-13" transform="translate(0.000000, 5.000000)" fill="#8954BA" fill-rule="nonzero">
                        <path d="M26.0555556,9.21052632 L27.5555556,9.21052632 L27.5555556,26.2 C27.5555556,27.1941125 26.7496681,28 25.7555556,28 L1.8,28 C0.80588745,28 7.8787749e-16,27.1941125 6.66133815e-16,26.2 L0,2.06315789 C-1.21743675e-16,1.06904535 0.80588745,0.263157895 1.8,0.263157895 L18.6666667,0.263157895 L18.6666667,1.76315789 L1.8,1.76315789 C1.63431458,1.76315789 1.5,1.89747247 1.5,2.06315789 L1.5,26.2 C1.5,26.3656854 1.63431458,26.5 1.8,26.5 L25.7555556,26.5 C25.921241,26.5 26.0555556,26.3656854 26.0555556,26.2 L26.0555556,9.21052632 Z" id="Combined-Shape"></path>
                    </g>
                    <g id="Group-12" transform="translate(3.444444, 8.736842)">
                        <path d="M14,13.0923151 L15.9333436,15.038378 C16.3741587,14.7701957 16.8912526,14.6157895 17.4444444,14.6157895 C19.0593745,14.6157895 20.3666667,15.9316823 20.3666667,17.5526316 C20.3666667,19.1735809 19.0593745,20.4894737 17.4444444,20.4894737 C15.8295144,20.4894737 14.5222222,19.1735809 14.5222222,17.5526316 C14.5222222,16.9953705 14.6767303,16.4741639 14.9451285,16.030084 L12.928313,14 L14,14 L14,13.0923151 Z M7.94750398,7 L7,7 L7,8.03268493 L4.7333231,5.75109568 C4.29250792,6.01927803 3.7754141,6.17368421 3.22222222,6.17368421 C1.6072922,6.17368421 0.3,4.85779141 0.3,3.23684211 C0.3,1.6158928 1.6072922,0.3 3.22222222,0.3 C4.83715225,0.3 6.14444444,1.6158928 6.14444444,3.23684211 C6.14444444,3.79410315 5.98993637,4.31530975 5.72153814,4.75938965 L7.94750398,7 Z M17.4444444,19.0894737 C18.2841133,19.0894737 18.9666667,18.4024298 18.9666667,17.5526316 C18.9666667,16.7028333 18.2841133,16.0157895 17.4444444,16.0157895 C16.6047756,16.0157895 15.9222222,16.7028333 15.9222222,17.5526316 C15.9222222,18.4024298 16.6047756,19.0894737 17.4444444,19.0894737 Z M3.22222222,4.77368421 C4.06189108,4.77368421 4.74444444,4.08664037 4.74444444,3.23684211 C4.74444444,2.38704384 4.06189108,1.7 3.22222222,1.7 C2.38255336,1.7 1.7,2.38704384 1.7,3.23684211 C1.7,4.08664037 2.38255336,4.77368421 3.22222222,4.77368421 Z" id="Combined-Shape" fill="#F6A31E" fill-rule="nonzero"></path>
                        <g id="Group-15" transform="translate(7.000000, 7.000000)" fill="#D8D8D8" stroke="#F6A31E">
                            <rect id="Rectangle" x="0.5" y="0.5" width="1" height="1"></rect>
                            <rect id="Rectangle" x="6.5" y="0.5" width="1" height="1"></rect>
                            <rect id="Rectangle" x="4.5" y="0.5" width="1" height="1"></rect>
                            <rect id="Rectangle" x="2.5" y="0.5" width="1" height="1"></rect>
                            <rect id="Rectangle" x="0.5" y="2.5" width="1" height="1"></rect>
                            <rect id="Rectangle" x="0.5" y="4.5" width="1" height="1"></rect>
                            <rect id="Rectangle" x="0.5" y="6.5" width="1" height="1"></rect>
                            <rect id="Rectangle" x="2.5" y="6.5" width="1" height="1"></rect>
                            <rect id="Rectangle" x="4.5" y="6.5" width="1" height="1"></rect>
                            <rect id="Rectangle" x="6.5" y="6.5" width="1" height="1"></rect>
                            <rect id="Rectangle" x="6.5" y="4.5" width="1" height="1"></rect>
                            <rect id="Rectangle" x="6.5" y="2.5" width="1" height="1"></rect>
                        </g>
                    </g>
                    <g id="Group-11" transform="translate(17.000000, 0.684211)" fill="#8954BA" fill-rule="nonzero">
                        <path d="M11.2930195,6.06302335 L9.20752233,3.96380581 L3.51870866,9.69004588 L4.81263733,10.248235 C4.91873388,10.2940041 5.00315914,10.3788312 5.04842392,10.4851439 L5.60383725,11.7896344 L11.2930195,6.06302335 Z M11.9273393,5.42453041 L13.1802543,4.16337253 L11.0947571,2.06415499 L9.84184212,3.32531287 L11.9273393,5.42453041 Z M3.1299866,10.5025279 L2.44940165,12.8689729 L4.79428402,12.1856866 L4.29086815,11.0033217 L3.1299866,10.5025279 Z M11.6268231,0.471411627 L14.76952,3.63478407 C15.0600986,3.92727442 15.0600986,4.39947063 14.76952,4.69196098 L6.30762024,13.2095311 C6.21814152,13.2995985 6.10726325,13.3654773 5.98537373,13.4009953 L1.56221654,14.6898797 C0.995048919,14.8551493 0.468332028,14.3302743 0.63161383,13.7625313 L1.91207422,9.31027435 C1.94695054,9.18900675 2.01185947,9.07849875 2.10079141,8.98898173 L10.5626911,0.471411627 C10.855977,0.176196237 11.3335373,0.176196237 11.6268231,0.471411627 Z" id="Combined-Shape"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: 'box',
    },
    width: {
      type: [Number, String],
      default: 18,
    },
    height: {
      type: [Number, String],
      default: 18,
    },
  },
};
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
  margin-bottom: -2px;
}
</style>
